<template>
  <div class="wo-container blocTitle">
    <div class="d-lg-flex align-center w-100">
      <v-toolbar-title
        class="d-flex my-2 my-lg-0 overflow-visible pl-2 justify-space-between"
        style="width: 100%"
      >
        <span>{{ title }}</span>
      </v-toolbar-title>
    </div>
    <slot name="button" />
  </div>
</template>

<script>
export default ({
    props: {
        title: {
            type: String,
            default: '',
        },
    },
});

</script>

<style lang="scss" scoped>
  .blocTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span {
      font-size: 25px !important;
      font-weight: 700 !important; font-size: 3rem;
      color : #26384B
    }
  }

</style>
